import { tags } from "../constants";
import { commonTransform } from "../handleTransformation";
import {
  GET_HIRING_MANAGER_PORTAL_CANDIDATES_URL,
  VALIDATE_HIRING_MANAGER_MAGIC_LINK,
  RESEND_HIRING_MANAGER_MAGIC_LINK_URL,
  GET_HIRING_MANAGER_FEEDBACK_INFO_URL,
  SUBMIT_HIRING_MANAGER_MEETING_PERSON_FEEDBACK_URL,
  GET_HIRING_MANAGER_CONFLICTING_TIME_SLOTS_URL,
  CREATE_HIRING_MANAGER_TIME_SLOTS_URL,
} from "services/url.service";

export const hiringManagerPortalMutations = {
  resendHiringManagerMagicLink: {
    getUrl: () => RESEND_HIRING_MANAGER_MAGIC_LINK_URL(),
    transformResponse: (res) => res,
    method: "POST",
  },
  submitHiringManagerMeetingPersonFeedback: {
    getUrl: (params) =>
      SUBMIT_HIRING_MANAGER_MEETING_PERSON_FEEDBACK_URL(params?.touchPointInstanceId),
    transformResponse: (res) => res,
    method: "POST",
    invalidatesTags: [tags?.HIRING_MANAGER_DASHBOARD],
  },
  createHiringManagerTimeSlots: {
    getUrl: (params) =>
      CREATE_HIRING_MANAGER_TIME_SLOTS_URL({ companyId: params?.companyId }),
    transformResponse: (res) => res,
    method: "POST",
    invalidatesTags: [tags.TIME_SLOTS, tags?.HIRING_MANAGER_DASHBOARD],
  },
};

export const hiringManagerPortalQueries = {
  getHiringManagerPortalCandidates: {
    getUrl: ({ companyId, search, offset, sort, filters }) =>
      GET_HIRING_MANAGER_PORTAL_CANDIDATES_URL(companyId, search, offset, sort, filters),
    transformResponse: (res) =>
      commonTransform(res) || { count: 0, rows: [] },
    method: "GET",
    providesTags: [tags.HIRING_MANAGER_PORTAL],
  },
  validateHiringManagerMagicLink: {
    getUrl: () => VALIDATE_HIRING_MANAGER_MAGIC_LINK(),
    transformResponse: (res) => res,
    method: "GET",
    providesTags: [tags?.HIRING_MANAGER_DASHBOARD],
  },
  getHiringManagerFeedbackInfo: {
    getUrl: ({ touchPointInstanceId }) =>
      GET_HIRING_MANAGER_FEEDBACK_INFO_URL(touchPointInstanceId),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
  getHiringManagerConflictingTimeSlots: {
    getUrl: ({ userId }) =>
      GET_HIRING_MANAGER_CONFLICTING_TIME_SLOTS_URL(userId),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.TIME_SLOTS],
  },
};
